var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mb-4" },
    [
      _c(
        "validation-observer",
        { ref: "formValidator", attrs: { novalidate: "", tag: "form" } },
        [
          _c(
            "custom-callout",
            {
              staticClass: "mb-4",
              attrs: { "border-color": "green", "has-toggle": false }
            },
            [
              _c("div", { staticClass: "mb-2" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("icon-view", {
                        attrs: {
                          icon: "fas fa-check-circle",
                          "icon-background": "#fff",
                          "icon-color": "#2db782",
                          "icon-size": "15px",
                          title: "Pago de Jornal"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "row mt-2 ml-1" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-date-picker", {
                                  attrs: {
                                    "custom-error-msg": "Fecha es requerida.",
                                    error: errors[0],
                                    label: "Fecha:",
                                    "max-date": new Date(),
                                    placeholder: "DD/MM/YYYY"
                                  },
                                  model: {
                                    value: _vm.model.paymentDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "paymentDate", $$v)
                                    },
                                    expression: "model.paymentDate"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col d-flex justify-content-end align-items-end pr-4 pr-md-5 pr-sm-4 mt-3 mt-md-0 mt-sm-3"
                    },
                    [
                      _c("action-button", {
                        attrs: {
                          i: "fas fa-times-circle",
                          text: "Cancelar",
                          variant:
                            "outline-danger btn-cancel danger pl-4 pr-4 mr-3"
                        },
                        on: { click: _vm.onCancelHandler }
                      }),
                      _c("action-button", {
                        attrs: {
                          i: "fas fa-arrow-circle-right",
                          text: "Continuar",
                          variant: "success pl-4 pr-4"
                        },
                        on: { click: _vm.onContinueHandler }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _c("hr")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }